







export default {
  name: 'GlassesIcon',
  props: {
    color: {
      type: String,
      default: '#959AA0'
    }
  }
}
